import { useMutation } from "@tanstack/react-query";
import { journalsServiceApi } from "@/entities/api";

type BuildSignLineParams = {
  sectionThreeListId?: string;
  sectionListId?: string;
  itemNoVersionId: string;
  signerEmployeeId: string;
};

const buildSignLine = async (params: BuildSignLineParams) => {
  const sectionThreeListId = params.sectionThreeListId || params.sectionListId || "";
  const { itemNoVersionId, signerEmployeeId } = params;
  const xAuth = localStorage.getItem("token");
  const response = await journalsServiceApi.post(
    `/journals/section-three/${sectionThreeListId}/items/${itemNoVersionId}/sign`,
    { signer: { signerEmployeeId } },
    {
      responseType: "text",
      headers: {
        "x-auth": xAuth,
      },
    },
  );

  return response.data;
};

export const useBuildSignLine = () => {
  return useMutation<string, Error, BuildSignLineParams>({
    mutationFn: buildSignLine,
  });
};
